// extracted by mini-css-extract-plugin
export default {"dcsc-logo":"styles-module__dcsc-logo___m4z7P","logo":"styles-module__logo____Coup","logo-text":"styles-module__logo-text___DzPGi"};